import { Container, Box, useMediaQuery, useTheme } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import React from "react";
import SitexSidebar from "./sidebar/SitexSidebar";
import { ImpersonationBanner } from "@ui/components/impersonation/ImpersonationBanner";
import { useResetOnNavigation } from "@ui/hooks/useResetOnNavigation";
const Layout = () => {
    const theme = useTheme();
    const location = useLocation();
    // Reset filters & pagination across all slices on page navigation
    useResetOnNavigation();
    const isMobile = useMediaQuery(theme.breakpoints.down("lg")); // Include tablets
    const isIpad = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");
    const isIpadMini = useMediaQuery("(min-width: 600px) and (max-width: 768px)");
    // Hide sidebar on unauthorized page
    const isUnauthorizedPage = location.pathname.includes("/unauthorized");
    return (React.createElement("main", { style: {
            display: "flex",
            height: "100dvh",
            overflow: "hidden",
        } },
        !isUnauthorizedPage && React.createElement(SitexSidebar, null),
        React.createElement(Box, { sx: {
                display: "flex",
                flexDirection: "column",
                flex: 1,
                minWidth: 0,
                overflow: "hidden",
                width: { xs: "100%", lg: "calc(100% - 280px)" },
            } },
            React.createElement(ImpersonationBanner, null),
            React.createElement(Container, { sx: {
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    minHeight: 0,
                    width: { xs: "100%" },
                    pl: isUnauthorizedPage ? 0 : { xs: 1.5, sm: 2, lg: 4 },
                    pt: isUnauthorizedPage ? 0 : { xs: 2, sm: 2, lg: 3 },
                    pr: 0,
                    overflow: "hidden",
                    maxWidth: isUnauthorizedPage
                        ? "100% !important"
                        : "1800px !important",
                }, maxWidth: false },
                React.createElement(Outlet, null)))));
};
export default Layout;
